module.exports = __webpack_public_path__ + "img/catalinasoto.4296f8b0.jpg";